import { allTrackers } from "app/services/track/track";

import createIndustryTrackingService from "./factory";

type IndustryTrackingService = ReturnType<typeof createIndustryTrackingService>;

let industryTrackingService: IndustryTrackingService | undefined;

/** Built on first event rather than at module eval, so importing this never depends on `allTrackers` being wired yet. */
const getIndustryTrackingService = (): IndustryTrackingService => {
    industryTrackingService ??= createIndustryTrackingService(allTrackers.dispatchTrackEvent.bind(allTrackers));

    return industryTrackingService;
};

const industryTrackingServiceFacade: IndustryTrackingService = {
    trackLaunchBannerCtaClick: (...args) => getIndustryTrackingService().trackLaunchBannerCtaClick(...args),
    trackLaunchBannerDismiss: (...args) => getIndustryTrackingService().trackLaunchBannerDismiss(...args),
    trackImpactReportOpen: (...args) => getIndustryTrackingService().trackImpactReportOpen(...args),
    trackImpactReportEnroll: (...args) => getIndustryTrackingService().trackImpactReportEnroll(...args),
    trackImpactReportEnrollRetry: (...args) => getIndustryTrackingService().trackImpactReportEnrollRetry(...args),
    trackImpactReportDismiss: (...args) => getIndustryTrackingService().trackImpactReportDismiss(...args),
    trackImpactReportContactUs: (...args) => getIndustryTrackingService().trackImpactReportContactUs(...args),
    trackImpactReportEnrollSuccess: (...args) => getIndustryTrackingService().trackImpactReportEnrollSuccess(...args),
    trackImpactReportViewLeadGeneration: (...args) =>
        getIndustryTrackingService().trackImpactReportViewLeadGeneration(...args),
    trackImpactReportCrmSettings: (...args) => getIndustryTrackingService().trackImpactReportCrmSettings(...args),
    trackSuggestionsImpression: (...args) => getIndustryTrackingService().trackSuggestionsImpression(...args),
    trackSuggestionAdd: (...args) => getIndustryTrackingService().trackSuggestionAdd(...args),
    trackSuggestionDismiss: (...args) => getIndustryTrackingService().trackSuggestionDismiss(...args),
};

export default industryTrackingServiceFacade;
